import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BRAND_NAME, generatePageTitle } from '../../utils/pageTitle';

type SeoProps = React.PropsWithChildren<{
  title?: string;
  metaDescription?: string;
  skipBrandName?: boolean;
}>;

export const Seo = ({ title, metaDescription, skipBrandName = false }: SeoProps) => {
  const getPageTitle = (): string => {
    if (!title) return BRAND_NAME;

    if (skipBrandName) return title;

    if (title.includes(`| ${BRAND_NAME}`)) return title;

    return generatePageTitle(title);
  };

  const pageTitle = getPageTitle();

  const {
    i18n: { language }
  } = useTranslation();

  return (
    <HelmetProvider>
      <Helmet htmlAttributes={{ lang: language }}>
        {pageTitle && <title>{pageTitle}</title>}
        {metaDescription && <meta name="description" content={metaDescription} />}
      </Helmet>
    </HelmetProvider>
  );
};
